module.exports = __webpack_public_path__ + "static/media/Хакимов А.Г..573868c9.pdf";